import { render, staticRenderFns } from "./RevenueFromToBox.vue?vue&type=template&id=27367618&"
import script from "./RevenueFromToBox.vue?vue&type=script&lang=js&"
export * from "./RevenueFromToBox.vue?vue&type=script&lang=js&"
import style0 from "./RevenueFromToBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports